<template>
  <b-modal v-model="show" centered size="md" @ok="onOk">
    <template #modal-title>
      <h3 class="font-weight-bold">{{ title ? title : 'Confirmation' }}</h3>
    </template>

    <b-row class="mb-4">
      <b-col>{{ message ? message : 'Are you sure?' }}</b-col>
    </b-row>
    <!-- Optional extra content (e.g. a tick box) under the message. -->
    <slot />

    <template #modal-footer>
      <div class="d-flex" style="gap: 16px">
        <b-button variant="secondary" @click="closeDialog">
          {{ cancelLabel }}
        </b-button>
        <b-button :variant="okVariant" @click="onOk">{{ okLabel }}</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmationModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    title: String,
    message: String,
    okLabel: {
      type: String,
      default: 'CONFIRM',
    },
    cancelLabel: {
      type: String,
      default: 'CANCEL',
    },
    okVariant: {
      type: String,
      default: 'primary',
    },
  },

  computed: {
    show: {
      get() {
        return this.showModal
      },
      set() {
        this.closeDialog()
      },
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close')
    },

    onOk() {
      this.$emit('ok')
      this.closeDialog()
    },
  },
}
</script>
